import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import TablePagination from '@mui/material/TablePagination';
import { useEffect, useState } from 'react';
import { Icon } from 'ui/styled';
import { Content, PaginationContainer, PaginationQuantity } from './styled';

// --- Estilização da Paginação ---
const CustomPagination = styled(TablePagination)(({ theme }) => ({
  // *AJUSTE DE TAMANHO DE FONTE* Aumentamos para 1rem para maior destaque e padronização.
  fontSize: '1rem',
  '& .MuiTablePagination-actions': {
    display: 'flex',
    marginLeft: 0,
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexShrink: 0,
  },
  '& .MuiButtonBase-root': {
    margin: theme.spacing(0.5),
    // Botões 44x44px
    minWidth: 44,
    height: 44,
    backgroundColor: theme.palette.colors.backgroundgrey,
    color: theme.palette.colors.black,
    '&.Mui-selected': {
      color: theme.palette.colors.white,
      backgroundColor: theme.palette.blue.main,
      '&:hover': {
        backgroundColor: theme.palette.blue.dark,
      },
    },
    '&:hover': {
      backgroundColor: theme.palette.colors.lightgrey,
    },
    '&:disabled': {
      backgroundColor: theme.palette.colors.lightgrey,
      color: theme.palette.colors.grey,
    },
  },
  '& .MuiTablePagination-toolbar': {
    padding: 0,
    minHeight: 52,
    justifyContent: 'flex-start', // Deixa o select e sua label à esquerda
    '& .MuiTablePagination-spacer': {
      display: 'none',
    },
    // *GARANTINDO PADRÃO* A label "Linhas por página" herda o novo tamanho de fonte.
    '& .MuiTablePagination-selectLabel': {
      alignItems: 'center',
      fontSize: '18px', // Essencial para o mesmo padrão do "Exibindo..."
      // marginRight: theme.spacing(1),
      lineHeight: '10px', // Alinha verticalmente com o select de 44px
      justifyContent: 'flex-start',
      textAlign: 'center',
      marginTop: '10px',
      fontFamily: 'Kumbh Sans',
      fontWeight: 600,
    },
    // Esconde o displayedRows padrão
    '& .MuiTablePagination-displayedRows': {
      display: 'none',
    },
    '& .MuiTablePagination-selectRoot': {
      display: 'flex',
      alignItems: 'center',
    },
  },
  // *AJUSTE DO QUADRADO SELECT* Mantido em 44x44 para alinhamento com os botões.
  '& .MuiTablePagination-select': {
    width: '65px',
    height: '34px',
    lineHeight: '34px',
    textAlign: 'center',
    padding: '0 24px 0 8px !important', // *AJUSTE* Padding para garantir espaço e centralização
    boxSizing: 'border-box',
    border: `1px solid ${theme.palette.colors.grey}`,
    // borderRadius: theme.shape.borderRadius,
    borderRadius: 5,
    backgroundColor: theme.palette.colors.backgroundgrey,
    fontSize: 'inherit', // Garante que o número dentro do select também use 1rem
    '&:focus': {
      backgroundColor: theme.palette.colors.backgroundgrey,
    },
  },
  // Ajuste do ícone para melhor posicionamento no quadrado de 44px
  '& .MuiTablePagination-selectIcon': {
    top: 'calc(50% - 10px)',
    right: '4px',
  },
}));

// --- Componente de Paginação ---
export default function CustomTablePagination(props) {
  const {
    count,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions = [10, 25, 50, 100],
  } = props;
  const totalPages = Math.ceil(count / rowsPerPage);
  const [displayedRows, setDisplayedRows] = useState(0);

  useEffect(() => {
    const start = page * rowsPerPage;
    const end = Math.min(count, start + rowsPerPage);
    setDisplayedRows(end - start);
  }, [page, rowsPerPage, count]);

  return (
    <CustomPagination
      component="div"
      count={count}
      page={page}
      onPageChange={onPageChange}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={rowsPerPageOptions}
      onRowsPerPageChange={onRowsPerPageChange}
      labelRowsPerPage="Linhas por página:"
      labelDisplayedRows={() => null}
      ActionsComponent={(subProps) => (
        <PaginationContainer>
          {/* O texto "Exibindo resultados" está aqui, alinhado à direita e usando 1rem */}
          <PaginationQuantity
            style={{
              fontSize: '18px',
              marginRight: '16px',
              fontFamily: 'Kumbh Sans',
            }}
          >
            {`Exibindo ${displayedRows} de ${count} resultados`}
          </PaginationQuantity>
          <Content className={subProps.className}>
            <Button
              onClick={(event) =>
                subProps.onPageChange(event, subProps.page - 1)
              }
              disabled={subProps.page === 0}
            >
              <Icon icon="arrow-left" nomargin />
            </Button>
            {[...Array(totalPages).keys()].map((pageNumber) => (
              <Button
                key={pageNumber}
                onClick={(event) => subProps.onPageChange(event, pageNumber)}
                className={subProps.page === pageNumber ? 'Mui-selected' : ''}
              >
                {pageNumber + 1}
              </Button>
            ))}
            <Button
              onClick={(event) =>
                subProps.onPageChange(event, subProps.page + 1)
              }
              disabled={subProps.page >= totalPages - 1}
            >
              <Icon icon="arrow-right" nomargin />
            </Button>
          </Content>
        </PaginationContainer>
      )}
    />
  );
}
